import { useCallback } from 'react';
import { CHAT_API_URL, CHAT_API_KEY } from './constants';

const getAudioFilename = (mimeType = '') => {
  if (mimeType.includes('webm')) return 'question.webm';
  if (mimeType.includes('wav')) return 'question.wav';
  if (mimeType.includes('mp4')) return 'question.mp4';
  if (mimeType.includes('ogg')) return 'question.ogg';
  return 'question.webm';
};

export const useSpeechRecognition = () => {
  const convertAudioToText = useCallback(async (audioBlob) => {
    try {
      console.log('Converting audio:', {
        type: audioBlob.type,
        size: audioBlob.size,
      });

      const formData = new FormData();
      formData.append('audio', audioBlob, getAudioFilename(audioBlob.type));
      formData.append('language', 'vi');

      const response = await fetch(`${CHAT_API_URL}/api/speech/transcribe`, {
        method: 'POST',
        headers: {
          Accept: '*/*',
          'X-API-Key': CHAT_API_KEY,
        },
        body: formData,
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(
          error.message || error.error || 'Speech-to-text conversion failed'
        );
      }

      const data = await response.json();
      return data.text || '';
    } catch (error) {
      console.error('Error converting audio to text:', error);
      alert('Lỗi chuyển đổi giọng nói sang văn bản: ' + error.message);
      return '';
    }
  }, []);

  return { convertAudioToText };
};
